import React, { FunctionComponent, ReactNode, Ref } from 'react'
import clsx from 'clsx'

import styles from './style.module.scss'
import { Text } from '../Typography'
import { noop } from '../utils/function'
import { MENU_ITEM_DISPLAY_NAME, MenuItemMarkup } from './constants'
import { useThemeClass } from '../Theme'

export interface MenuItemProps {
  children?: ReactNode
  disabled?: boolean
  focus?: boolean
  disableHighlight?: boolean
  onClick?: (e: any) => void
  onMouseEnter?: any
  onMouseLeave?: any
  onMouseDown?: any
  onMouseUp?: any
  onTouchStart?: any
  onTouchEnd?: any
  renderAs?: MenuItemMarkup
  selected?: boolean
  tabIndex?: number
  testNameSpace?: string
  value?: string
  id?: string
  role?: string
  idValue?: string
  'aria-disabled'?: boolean
  'aria-labelledby'?: string
  'aria-describedby'?: string
  innerRef?: Ref<any>
}

const BaseMenuItem: FunctionComponent<MenuItemProps> = ({
  children,
  disabled = false,
  focus = false,
  disableHighlight = false,
  onClick = noop,
  renderAs = MenuItemMarkup.div,
  selected = false,
  testNameSpace = '',
  value = '',
  id,
  idValue,
  role = 'option',
  innerRef,
  ...otherProps
}) => {
  const themeClass = useThemeClass()
  const componentStyle = clsx(
    styles.menuItem,
    disabled && styles.disabled,
    selected && styles.selected,
    focus && styles.focus,
    disableHighlight && styles.disableHighlight,
    styles[`${themeClass}`]
  )

  if (disabled) {
    // tabIndex = -1
    otherProps['aria-disabled'] = true
  }

  const handleClick = (): void => {
    if (!disabled) {
      onClick(value)
    }
  }

  const HTML = renderAs

  return (
    <HTML
      role={role}
      ref={innerRef}
      aria-selected={selected || focus}
      onClick={handleClick}
      tabIndex={-1}
      id={idValue}
      className={componentStyle}
      {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-dropdown-menu-item` })}
      {...otherProps}
    >
      <Text renderAs='div'>{children}</Text>
    </HTML>
  )
}

export const MenuItem = BaseMenuItem

MenuItem.displayName = MENU_ITEM_DISPLAY_NAME
